/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ProfilesUpdateBillingDetailsPathParams,
	ProfilesUpdateBillingDetailsRequest,
	ProfilesUpdateBillingDetailsResponse,
} from '../types/ProfilesUpdateBillingDetails'

/**
 * PUT /:organisation/profiles/:profile/billing-details
 * @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::updateBillingDetails
 */
export async function profilesUpdateBillingDetails(
	organisation: ProfilesUpdateBillingDetailsPathParams['organisation'],
	profile: ProfilesUpdateBillingDetailsPathParams['profile'],
	data: ProfilesUpdateBillingDetailsRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ProfilesUpdateBillingDetailsResponse>> {
	return axiosInstance.put(`/${organisation}/profiles/${profile}/billing-details`, data, config)
}
